<app-edit-non-owner-personnel
  [nonOwnerPersonnel]="nonOwnerPersonnel"
  [processing]="(processing$ | async)"
  (deleteNonOwnerPersonnel)="deleteNonOwnerPersonnel($event)"
  (saveNonOwnerPersonnel)="saveNonOwnerPersonnel($event)">
</app-edit-non-owner-personnel>
